<template>
  <div>
    <p v-if="showTitle" class="title">Network</p>
    <template v-for="(iface, i) in interfaces">
      <p :key="iface.name" class="subtitle has-text-centered">{{ iface.name }}</p>
      <p :key="i" class="has-text-centered"><span class="subtitle is-3 has-text-info">⇩{{iface.netDownUsage}}</span> MB/s <span class="subtitle is-3 has-text-success">⇧{{ iface.netUpUsage }}</span> MB/s</p>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    serverUrl: {
      type: String,
      default: ""
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      interfaces: []
    };
  },
  created() {
    setTimeout(() => {
      this.startMonitor();
    }, 1000);
  },
  methods: {
    startMonitor() {
      this.$http
        .get(this.serverUrl + "network.php?ifaces=eth0;docker0")
        .then(response => {
          let result = response.data;

          for (let i = 0; i < result.length; i++) {
            let iface = this.getInterfaceByName(result[i].name);
            if (iface == null) {
              iface = this.createNewInterface(result[i]);
              iface.current_results.rx = result[i].rx;
              iface.current_results.tx = result[i].tx;
              iface.last_results.rx = result[i].rx;
              iface.last_results.tx = result[i].tx;
              iface.netDownUsage = (0).toFixed(2);
              iface.netUpUsage = (0).toFixed(2);
              this.interfaces.push(iface);
            } else {
              iface.current_results.rx = result[i].rx;
              iface.current_results.tx = result[i].tx;

              iface.netDownUsage = (
                (iface.current_results.rx - iface.last_results.rx) /
                1024 /
                1024 /
                4
              ).toFixed(2);
              iface.netUpUsage = (
                (iface.current_results.tx - iface.last_results.tx) /
                1024 /
                1024 /
                4
              ).toFixed(2);

              iface.last_results.rx = result[i].rx;
              iface.last_results.tx = result[i].tx;
            }
          }
          setTimeout(() => {
            this.startMonitor();
          }, 4000);
        })
        .catch(error => {
          setTimeout(() => {
            this.startMonitor();
          }, 1000);
        });
    },
    getInterfaceByName(name) {
      for (let i = 0; i < this.interfaces.length; i++) {
        if (this.interfaces[i].name == name) {
          return this.interfaces[i];
        }
      }
      return null;
    },
    createNewInterface(basedon) {
      return {
        name: basedon.name,
        netDownUsage: 0,
        netUpUsage: 0,
        current_results: {
          rx: 0,
          tx: 0
        },
        last_results: {
          rx: 0,
          tx: 0
        }
      };
    }
  }
};
</script>
<style scoped>
.subtitle {
  margin-bottom: 0;
}
.subtitle:not(:first-child) {
  margin-top: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// app/monitor/src/components/MonitorNetwork.vue